import styled from 'styled-components';
import ContentfulImageRenderer from 'contentful/image_renderer';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';
import Container from './shared/container';

const QuoteBox = ({
  content: {
    header,
    content,
    name,
    title,
    authorImage,
    backgroundColor = 'grey',
    fullWidth = false,
  },
  ...rest
}) => (
  <QuoteWrapper
    backgroundColor={backgroundColor}
    isFullWidth={fullWidth}
    {...rest}>
    {authorImage && (
      <QuoteBoxImage>
        <ContentfulImageRenderer image={authorImage} />
      </QuoteBoxImage>
    )}
    <div>
      {header && <Header>{header}</Header>}
      <p className={`fs-18 lh-1-5 ${name ? 'mb-24' : ''}`}>{content}</p>

      {(name || title) && (
        <p>
          {name && (
            <span className="evergreen__grey-section--content__author-name fs-14 fw-600">
              {name}
            </span>
          )}

          {title && (
            <span className="evergreen__grey-section--content__author-title fs-14">
              {title}
            </span>
          )}
        </p>
      )}
    </div>
  </QuoteWrapper>
);

const QuoteWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: ${toRem(32)};

  ${responsive('tabletSmall')} {
    flex-direction: row;
  }
`;

const Header = styled.h2`
  font-size: ${toRem(24)};
  line-height: ${toRem(30)};
  margin-bottom: ${toRem(28)};
`;

const QuoteBoxImage = styled.div`
  width: 200px;
  flex-shrink: 0;

  img {
    width: 100%;
  }
`;

export default QuoteBox;
